import { useState, useEffect, useRef } from "react";

export function useIsMobile(breakpoint = 768) {
  // Default to mobile: most traffic is mobile, so assuming mobile on the first render (before the
  // effect measures) shows the right layout to the majority and avoids a desktop→mobile flash.
  const [isMobile, setIsMobile] = useState(true);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    const checkIsMobile = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setIsMobile(window.innerWidth < breakpoint);
      }, 150);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => {
      window.removeEventListener("resize", checkIsMobile);
      clearTimeout(timerRef.current);
    };
  }, [breakpoint]);

  return isMobile;
}
